export enum ProviderPlan {
  Deluxe = 'deluxe',
  Commission = 'commission',
}
